import { useQuery } from '@tanstack/react-query';
import api from '../api';
import Recruiters from '../pages/Recruiters';

export default function RecruiterProfileModal({ recruiterId, initialRecruiter = null, onClose }) {
  const { data: recruiters, isLoading } = useQuery({
    queryKey: ['recruiters'],
    queryFn: () => api.get('/recruiters').then(r => r.data),
    enabled: Boolean(recruiterId) && !initialRecruiter
  });

  const recruiter =
    initialRecruiter?.id === recruiterId
      ? initialRecruiter
      : (Array.isArray(recruiters) ? recruiters.find(r => r.id === recruiterId) : null);

  if (!recruiterId) return null;

  if (isLoading && !recruiter) {
    return (
      <div className="fixed inset-0 z-[14000] bg-black/50 flex items-center justify-center p-4">
        <div className="bg-[hsl(var(--ds-surface))] border border-[hsl(var(--ds-border))] rounded-xl px-6 py-4 text-sm text-[hsl(var(--ds-fg))] shadow-xl">
          Loading recruiter…
        </div>
      </div>
    );
  }

  if (!recruiter) {
    return (
      <div
        className="fixed inset-0 z-[14000] bg-black/50 flex items-center justify-center p-4"
        onClick={onClose}
      >
        <div
          className="bg-[hsl(var(--ds-surface))] border border-[hsl(var(--ds-border))] rounded-xl px-6 py-4 text-sm shadow-xl max-w-sm"
          onClick={e => e.stopPropagation()}
        >
          <p className="text-[hsl(var(--ds-fg))] mb-3">Could not load this recruiter.</p>
          <button
            type="button"
            className="px-3 py-1.5 text-sm border border-[hsl(var(--ds-border))] hover:bg-[hsl(var(--ds-muted))] rounded-lg"
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </div>
    );
  }

  return (
    <Recruiters
      embedded
      embeddedEditId={recruiterId}
      initialRecruiter={recruiter}
      onEmbeddedClose={onClose}
    />
  );
}
